//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../bannertextprimaryCommon.scss'

// @ADD Component types
interface IBannertextprimaryCommonLayoutProps {
	text: string
}

const BannertextprimaryCommonLayout: React.FC<IBannertextprimaryCommonLayoutProps> = (props) => {

  const {text} = props
  const { t } = useTranslation()

  return(
    <div className='banner-text-primary'>
    	{text}
    </div>
  )
}

export default BannertextprimaryCommonLayout
